const base = {
  id: 'historicalMap',
  type: 'raster',
  source: 'histMap',
  paint: {
    'raster-opacity': 0.5,
    'raster-fade-duration': 0,
    'raster-saturation': -0.3,
    // 'raster-contrast': +0.1,
  },
}

const config = {
  1866: {
    'raster-saturation': -0.1,
    'raster-brightness-min': 0,
    // 'raster-contrast': +0.2,
  },
  1911: {
    'raster-saturation': 0,
    'raster-brightness-min': 0,
  },
  1946: {
    'raster-brightness-min': 0.3,
    'raster-saturation': -0.7,
  },
  1949: {
    'raster-saturation': -0.2,
    'raster-brightness-min': 0,
  },
}

export default year => ({
  ...base,
  paint: {
    ...base.paint,
    ...config[year],
  },
})
